// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-header {
  position: relative;
  backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.95);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}
[data-coreui-theme=dark] .app-header {
  background: rgba(33, 37, 41, 0.95);
  border-bottom-color: rgba(255, 255, 255, 0.1);
}
.app-header.shadow-sm {
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
}
.app-header .user-avatar {
  position: relative;
  transition: all 0.3s ease;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}
.app-header .user-avatar:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);
}
.app-header .user-avatar::after {
  content: "";
  position: absolute;
  top: -2px;
  left: -2px;
  right: -2px;
  bottom: -2px;
  background: linear-gradient(45deg, #667eea, #764ba2, #f093fb, #f5576c);
  border-radius: inherit;
  z-index: -1;
  opacity: 0;
  transition: opacity 0.3s ease;
}
.app-header .user-avatar:hover::after {
  opacity: 1;
}
.app-header .user-guide-btn {
  position: relative;
  padding: 8px 16px;
  border-radius: 12px;
  background: rgba(102, 126, 234, 0.1);
  border: 2px solid rgba(102, 126, 234, 0.2);
  color: #667eea;
  font-weight: 600;
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  overflow: hidden;
}
[data-coreui-theme=dark] .app-header .user-guide-btn {
  background: rgba(102, 126, 234, 0.15);
  border-color: rgba(102, 126, 234, 0.3);
  color: #8da3f0;
}
.app-header .user-guide-btn::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.3) 50%, rgba(255, 255, 255, 0) 100%);
  transition: left 0.5s ease;
  z-index: 1;
}
.app-header .user-guide-btn:hover {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-color: #667eea;
  color: white;
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);
}
.app-header .user-guide-btn:hover::before {
  left: 100%;
}
.app-header .user-guide-btn:hover .user-guide-text {
  color: white;
}
.app-header .user-guide-btn:focus {
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.3);
  outline: none;
}
.app-header .user-guide-btn .user-guide-text {
  position: relative;
  z-index: 2;
  font-size: 0.875rem;
  letter-spacing: 0.5px;
  transition: color 0.3s ease;
}
.app-header .user-guide-btn .icon {
  position: relative;
  z-index: 2;
  transition: all 0.3s ease;
}
.app-header .user-guide-btn:hover .icon {
  animation: bookFlip 0.6s ease;
}
.app-header .dropdown-menu {
  border: none;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
  border-radius: 12px;
  padding: 8px;
  backdrop-filter: blur(20px);
  background: rgba(255, 255, 255, 0.95);
}
[data-coreui-theme=dark] .app-header .dropdown-menu {
  background: rgba(33, 37, 41, 0.95);
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}
.app-header .dropdown-menu .dropdown-item {
  border-radius: 8px;
  transition: all 0.2s ease;
  margin: 2px 0;
}
.app-header .dropdown-menu .dropdown-item:hover {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  transform: translateX(4px);
}
.app-header .dropdown-menu .dropdown-item.text-danger:hover {
  background: linear-gradient(135deg, #ff416c 0%, #ff4b2b 100%);
}

.password-change-modal .modal-content {
  border: none;
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(20px);
  background: rgba(255, 255, 255, 0.98);
}
[data-coreui-theme=dark] .password-change-modal .modal-content {
  background: rgba(33, 37, 41, 0.98);
}
.password-change-modal .modal-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 20px 20px 0 0;
  padding: 1.5rem 2rem;
}
.password-change-modal .modal-header .modal-title {
  font-weight: 600;
  display: flex;
  align-items: center;
}
.password-change-modal .modal-header .modal-title .icon {
  margin-right: 12px;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
}
.password-change-modal .modal-header .btn-close {
  filter: brightness(0) invert(1);
  opacity: 0.8;
  transition: all 0.2s ease;
}
.password-change-modal .modal-header .btn-close:hover {
  opacity: 1;
  transform: scale(1.1);
}
.password-change-modal .modal-body {
  padding: 2rem;
}
.password-change-modal .modal-body .password-form-card {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 16px;
  padding: 2rem;
  position: relative;
  overflow: hidden;
}
[data-coreui-theme=dark] .password-change-modal .modal-body .password-form-card {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.1);
}
.password-change-modal .modal-body .password-form-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #667eea, #764ba2, #f093fb, #f5576c);
  background-size: 300% 100%;
  animation: gradientShift 3s ease-in-out infinite;
}
.password-change-modal .password-input-group {
  position: relative;
  margin-bottom: 1.5rem;
}
.password-change-modal .password-input-group .form-label {
  font-weight: 600;
  color: #495057;
  margin-bottom: 0.75rem;
}
[data-coreui-theme=dark] .password-change-modal .password-input-group .form-label {
  color: #e9ecef;
}
.password-change-modal .password-input-group .input-group {
  position: relative;
}
.password-change-modal .password-input-group .input-group .form-control {
  border: 2px solid #e9ecef;
  border-radius: 12px;
  padding: 12px 16px;
  font-size: 1rem;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.9);
}
[data-coreui-theme=dark] .password-change-modal .password-input-group .input-group .form-control {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.1);
  color: #e9ecef;
}
.password-change-modal .password-input-group .input-group .form-control:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
  background: white;
}
[data-coreui-theme=dark] .password-change-modal .password-input-group .input-group .form-control:focus {
  background: rgba(255, 255, 255, 0.1);
}
.password-change-modal .password-input-group .input-group .form-control.is-invalid {
  border-color: #dc3545;
  box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);
}
.password-change-modal .password-input-group .input-group .form-control:not(:placeholder-shown) {
  background: rgba(102, 126, 234, 0.02);
}
[data-coreui-theme=dark] .password-change-modal .password-input-group .input-group .form-control:not(:placeholder-shown) {
  background: rgba(255, 255, 255, 0.08);
}
.password-change-modal .password-input-group .input-group .input-group-text {
  border: 2px solid #e9ecef;
  border-left: none;
  border-radius: 0 12px 12px 0;
  background: transparent;
  cursor: pointer;
  transition: all 0.3s ease;
}
[data-coreui-theme=dark] .password-change-modal .password-input-group .input-group .input-group-text {
  border-color: rgba(255, 255, 255, 0.1);
}
.password-change-modal .password-input-group .input-group .input-group-text:hover {
  background: rgba(102, 126, 234, 0.1);
  border-color: #667eea;
}
.password-change-modal .password-input-group .input-group .input-group-text:hover .icon {
  color: #667eea;
  transform: scale(1.1);
}
.password-change-modal .password-input-group .input-group .input-group-text .icon {
  transition: all 0.2s ease;
  color: #6c757d;
}
[data-coreui-theme=dark] .password-change-modal .password-input-group .input-group .input-group-text .icon {
  color: #adb5bd;
}
.password-change-modal .password-strength-indicator {
  margin-top: 1rem;
}
.password-change-modal .password-strength-indicator .strength-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}
.password-change-modal .password-strength-indicator .strength-header .strength-label {
  font-size: 0.875rem;
  color: #6c757d;
  font-weight: 500;
}
[data-coreui-theme=dark] .password-change-modal .password-strength-indicator .strength-header .strength-label {
  color: #adb5bd;
}
.password-change-modal .password-strength-indicator .strength-header .strength-text {
  font-size: 0.875rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.password-change-modal .password-strength-indicator .progress {
  height: 8px;
  border-radius: 20px;
  background: rgba(0, 0, 0, 0.1);
  overflow: hidden;
}
[data-coreui-theme=dark] .password-change-modal .password-strength-indicator .progress {
  background: rgba(255, 255, 255, 0.1);
}
.password-change-modal .password-strength-indicator .progress .progress-bar {
  border-radius: 20px;
  transition: all 0.5s ease;
  position: relative;
}
.password-change-modal .password-strength-indicator .progress .progress-bar::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0.1) 50%, rgba(255, 255, 255, 0.3) 100%);
  animation: shimmer 2s infinite;
}
.password-change-modal .password-strength-indicator .strength-requirements {
  font-size: 0.75rem;
  color: #6c757d;
  margin-top: 0.5rem;
  line-height: 1.4;
}
[data-coreui-theme=dark] .password-change-modal .password-strength-indicator .strength-requirements {
  color: #adb5bd;
}
.password-change-modal .password-match-indicator {
  margin-top: 0.5rem;
}
.password-change-modal .password-match-indicator .match-text {
  font-size: 0.875rem;
  display: flex;
  align-items: center;
  font-weight: 500;
}
.password-change-modal .password-match-indicator .match-text .icon {
  margin-right: 0.5rem;
  transition: all 0.2s ease;
}
.password-change-modal .password-match-indicator .match-text.text-success .icon {
  animation: checkmark 0.5s ease;
}
.password-change-modal .password-match-indicator .match-text.text-danger .icon {
  animation: shake 0.5s ease;
}
.password-change-modal .alert {
  border: none;
  border-radius: 12px;
  padding: 1rem 1.25rem;
  backdrop-filter: blur(10px);
}
.password-change-modal .alert.alert-danger {
  background: rgba(220, 53, 69, 0.1);
  color: #721c24;
  border-left: 4px solid #dc3545;
}
[data-coreui-theme=dark] .password-change-modal .alert.alert-danger {
  background: rgba(220, 53, 69, 0.2);
  color: #f8d7da;
}
.password-change-modal .alert.alert-success {
  background: rgba(25, 135, 84, 0.1);
  color: #0a3622;
  border-left: 4px solid #198754;
}
[data-coreui-theme=dark] .password-change-modal .alert.alert-success {
  background: rgba(25, 135, 84, 0.2);
  color: #d1e7dd;
}
.password-change-modal .modal-footer {
  padding: 1.5rem 2rem 2rem;
  border: none;
}
.password-change-modal .modal-footer .btn {
  border-radius: 12px;
  padding: 12px 24px;
  font-weight: 600;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}
.password-change-modal .modal-footer .btn::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  transform: translate(-50%, -50%);
  transition: all 0.5s ease;
}
.password-change-modal .modal-footer .btn:hover::before {
  width: 200px;
  height: 200px;
}
.password-change-modal .modal-footer .btn.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
}
.password-change-modal .modal-footer .btn.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);
}
.password-change-modal .modal-footer .btn.btn-primary:disabled {
  background: #6c757d;
  transform: none;
  box-shadow: none;
}
.password-change-modal .modal-footer .btn.btn-light {
  background: rgba(248, 249, 250, 0.9);
  backdrop-filter: blur(10px);
  border: 2px solid rgba(0, 0, 0, 0.1);
}
[data-coreui-theme=dark] .password-change-modal .modal-footer .btn.btn-light {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.2);
  color: #e9ecef;
}
.password-change-modal .modal-footer .btn.btn-light:hover {
  background: rgb(248, 249, 250);
  transform: translateY(-1px);
}
[data-coreui-theme=dark] .password-change-modal .modal-footer .btn.btn-light:hover {
  background: rgba(255, 255, 255, 0.2);
}

@keyframes gradientShift {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}
@keyframes checkmark {
  0% {
    transform: scale(0.8);
    opacity: 0;
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
@keyframes shake {
  0%, 100% {
    transform: translateX(0);
  }
  10%, 30%, 50%, 70%, 90% {
    transform: translateX(-2px);
  }
  20%, 40%, 60%, 80% {
    transform: translateX(2px);
  }
}
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes bookFlip {
  0% {
    transform: rotateY(0deg);
  }
  50% {
    transform: rotateY(20deg) scale(1.1);
  }
  100% {
    transform: rotateY(0deg);
  }
}
.spinner-border-sm {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@media (max-width: 768px) {
  .app-header .user-guide-btn {
    padding: 6px 12px;
  }
  .app-header .user-guide-btn .user-guide-text {
    font-size: 0.8rem;
  }
  .password-change-modal .modal-content {
    margin: 1rem;
    border-radius: 16px;
  }
  .password-change-modal .modal-header {
    padding: 1rem 1.5rem;
    border-radius: 16px 16px 0 0;
  }
  .password-change-modal .modal-body {
    padding: 1.5rem;
  }
  .password-change-modal .modal-body .password-form-card {
    padding: 1.5rem;
  }
  .password-change-modal .modal-footer {
    padding: 1rem 1.5rem 1.5rem;
  }
  .password-change-modal .modal-footer .btn {
    padding: 10px 20px;
    font-size: 0.9rem;
  }
  .password-input-group {
    margin-bottom: 1rem;
  }
  .password-input-group .input-group .form-control {
    padding: 10px 14px;
    font-size: 0.9rem;
  }
}
@media (max-width: 1199px) {
  .app-header .user-guide-btn .user-guide-text {
    display: none;
  }
}
[data-coreui-theme=dark] .password-change-modal .modal-content {
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
}
[data-coreui-theme=dark] .password-strength-indicator .progress {
  background: rgba(255, 255, 255, 0.1);
}

.cursor-pointer {
  cursor: pointer !important;
}

.glassmorphism {
  backdrop-filter: blur(20px);
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.gradient-text {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.fade-in-up {
  animation: fadeInUp 0.5s ease forwards;
}`, "",{"version":3,"sources":["webpack://./src/components/AppHeader.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,2BAAA;EACA,qCAAA;EACA,2CAAA;EACA,yBAAA;AADF;AAGE;EACE,kCAAA;EACA,6CAAA;AADJ;AAIE;EACE,yCAAA;AAFJ;AAME;EACE,kBAAA;EACA,yBAAA;EACA,6DAAA;AAJJ;AAMI;EACE,2BAAA;EACA,+CAAA;AAJN;AAOI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,sEAAA;EACA,sBAAA;EACA,WAAA;EACA,UAAA;EACA,6BAAA;AALN;AAQI;EACE,UAAA;AANN;AAWE;EACE,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,oCAAA;EACA,0CAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,2BAAA;EACA,gBAAA;AATJ;AAWI;EACE,qCAAA;EACA,sCAAA;EACA,cAAA;AATN;AAYI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,wHAAA;EAIA,0BAAA;EACA,UAAA;AAbN;AAgBI;EACE,6DAAA;EACA,qBAAA;EACA,YAAA;EACA,2BAAA;EACA,+CAAA;AAdN;AAgBM;EACE,UAAA;AAdR;AAiBM;EACE,YAAA;AAfR;AAmBI;EACE,8CAAA;EACA,aAAA;AAjBN;AAoBI;EACE,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,qBAAA;EACA,2BAAA;AAlBN;AAqBI;EACE,kBAAA;EACA,UAAA;EACA,yBAAA;AAnBN;AAuBI;EACE,6BAAA;AArBN;AA0BE;EACE,YAAA;EACA,2CAAA;EACA,mBAAA;EACA,YAAA;EACA,2BAAA;EACA,qCAAA;AAxBJ;AA0BI;EACE,kCAAA;EACA,0CAAA;AAxBN;AA2BI;EACE,kBAAA;EACA,yBAAA;EACA,aAAA;AAzBN;AA2BM;EACE,6DAAA;EACA,YAAA;EACA,0BAAA;AAzBR;AA4BM;EACE,6DAAA;AA1BR;;AAkCE;EACE,YAAA;EACA,mBAAA;EACA,0CAAA;EACA,2BAAA;EACA,qCAAA;AA/BJ;AAiCI;EACE,kCAAA;AA/BN;AAmCE;EACE,6DAAA;EACA,YAAA;EACA,4BAAA;EACA,oBAAA;AAjCJ;AAmCI;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;AAjCN;AAmCM;EACE,kBAAA;EACA,iDAAA;AAjCR;AAqCI;EACE,+BAAA;EACA,YAAA;EACA,yBAAA;AAnCN;AAqCM;EACE,UAAA;EACA,qBAAA;AAnCR;AAwCE;EACE,aAAA;AAtCJ;AAwCI;EACE,oCAAA;EACA,2BAAA;EACA,0CAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;AAtCN;AAwCM;EACE,qCAAA;EACA,sCAAA;AAtCR;AAyCM;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,WAAA;EACA,sEAAA;EACA,0BAAA;EACA,gDAAA;AAvCR;AA6CE;EACE,kBAAA;EACA,qBAAA;AA3CJ;AA6CI;EACE,gBAAA;EACA,cAAA;EACA,sBAAA;AA3CN;AA6CM;EACE,cAAA;AA3CR;AA+CI;EACE,kBAAA;AA7CN;AA+CM;EACE,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,oCAAA;AA7CR;AA+CQ;EACE,qCAAA;EACA,sCAAA;EACA,cAAA;AA7CV;AAgDQ;EACE,qBAAA;EACA,8CAAA;EACA,iBAAA;AA9CV;AAgDU;EACE,oCAAA;AA9CZ;AAkDQ;EACE,qBAAA;EACA,4CAAA;AAhDV;AAmDQ;EACE,qCAAA;AAjDV;AAmDU;EACE,qCAAA;AAjDZ;AAsDM;EACE,yBAAA;EACA,iBAAA;EACA,4BAAA;EACA,uBAAA;EACA,eAAA;EACA,yBAAA;AApDR;AAsDQ;EACE,sCAAA;AApDV;AAuDQ;EACE,oCAAA;EACA,qBAAA;AArDV;AAuDU;EACE,cAAA;EACA,qBAAA;AArDZ;AAyDQ;EACE,yBAAA;EACA,cAAA;AAvDV;AAyDU;EACE,cAAA;AAvDZ;AA+DE;EACE,gBAAA;AA7DJ;AA+DI;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,qBAAA;AA7DN;AA+DM;EACE,mBAAA;EACA,cAAA;EACA,gBAAA;AA7DR;AA+DQ;EACE,cAAA;AA7DV;AAiEM;EACE,mBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AA/DR;AAmEI;EACE,WAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AAjEN;AAmEM;EACE,oCAAA;AAjER;AAoEM;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;AAlER;AAoEQ;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,4HAAA;EAIA,8BAAA;AArEV;AA0EI;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;AAxEN;AA0EM;EACE,cAAA;AAxER;AA8EE;EACE,kBAAA;AA5EJ;AA8EI;EACE,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AA5EN;AA8EM;EACE,oBAAA;EACA,yBAAA;AA5ER;AA+EM;EACE,8BAAA;AA7ER;AAgFM;EACE,0BAAA;AA9ER;AAoFE;EACE,YAAA;EACA,mBAAA;EACA,qBAAA;EACA,2BAAA;AAlFJ;AAoFI;EACE,kCAAA;EACA,cAAA;EACA,8BAAA;AAlFN;AAoFM;EACE,kCAAA;EACA,cAAA;AAlFR;AAsFI;EACE,kCAAA;EACA,cAAA;EACA,8BAAA;AApFN;AAsFM;EACE,kCAAA;EACA,cAAA;AApFR;AA0FE;EACE,yBAAA;EACA,YAAA;AAxFJ;AA0FI;EACE,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AAxFN;AA0FM;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,kBAAA;EACA,gCAAA;EACA,yBAAA;AAxFR;AA2FM;EACE,YAAA;EACA,aAAA;AAzFR;AA4FM;EACE,6DAAA;EACA,YAAA;AA1FR;AA4FQ;EACE,2BAAA;EACA,+CAAA;AA1FV;AA6FQ;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;AA3FV;AA+FM;EACE,oCAAA;EACA,2BAAA;EACA,oCAAA;AA7FR;AA+FQ;EACE,oCAAA;EACA,sCAAA;EACA,cAAA;AA7FV;AAgGQ;EACE,8BAAA;EACA,2BAAA;AA9FV;AAgGU;EACE,oCAAA;AA9FZ;;AAuGA;EACE;IAAK,2BAAA;EAnGL;EAoGA;IAAM,6BAAA;EAjGN;EAkGA;IAAO,2BAAA;EA/FP;AACF;AAiGA;EACE;IAAK,4BAAA;EA9FL;EA+FA;IAAO,2BAAA;EA5FP;AACF;AA8FA;EACE;IAAK,qBAAA;IAAuB,UAAA;EA1F5B;EA2FA;IAAM,qBAAA;EAxFN;EAyFA;IAAO,mBAAA;IAAqB,UAAA;EArF5B;AACF;AAuFA;EACE;IAAW,wBAAA;EApFX;EAqFA;IAA0B,2BAAA;EAlF1B;EAmFA;IAAqB,0BAAA;EAhFrB;AACF;AAkFA;EACE;IACE,UAAA;IACA,2BAAA;EAhFF;EAkFA;IACE,UAAA;IACA,wBAAA;EAhFF;AACF;AAmFA;EACE;IAAK,wBAAA;EAhFL;EAiFA;IAAM,oCAAA;EA9EN;EA+EA;IAAO,wBAAA;EA5EP;AACF;AA+EA;EACE,kCAAA;AA7EF;;AAgFA;EACE;IAAK,uBAAA;EA5EL;EA6EA;IAAO,yBAAA;EA1EP;AACF;AA6EA;EAEI;IACE,iBAAA;EA5EJ;EA8EI;IACE,iBAAA;EA5EN;EAkFE;IACE,YAAA;IACA,mBAAA;EAhFJ;EAmFE;IACE,oBAAA;IACA,4BAAA;EAjFJ;EAoFE;IACE,eAAA;EAlFJ;EAoFI;IACE,eAAA;EAlFN;EAsFE;IACE,2BAAA;EApFJ;EAsFI;IACE,kBAAA;IACA,iBAAA;EApFN;EAyFA;IACE,mBAAA;EAvFF;EAyFE;IACE,kBAAA;IACA,iBAAA;EAvFJ;AACF;AA4FA;EAGM;IACE,aAAA;EA5FN;AACF;AAoGI;EACE,0CAAA;AAlGN;AAuGI;EACE,oCAAA;AArGN;;AA2GA;EACE,0BAAA;AAxGF;;AA2GA;EACE,2BAAA;EACA,oCAAA;EACA,0CAAA;AAxGF;;AA2GA;EACE,6DAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;AAxGF;;AA2GA;EACE,sCAAA;AAxGF","sourcesContent":["// AppHeader.scss - Modern styling for enhanced header and password modal\n\n.app-header {\n  position: relative;\n  backdrop-filter: blur(10px);\n  background: rgba(255, 255, 255, 0.95);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n\n  [data-coreui-theme=\"dark\"] & {\n    background: rgba(33, 37, 41, 0.95);\n    border-bottom-color: rgba(255, 255, 255, 0.1);\n  }\n\n  &.shadow-sm {\n    box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);\n  }\n\n  // User Avatar Enhancement\n  .user-avatar {\n    position: relative;\n    transition: all 0.3s ease;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    \n    &:hover {\n      transform: translateY(-1px);\n      box-shadow: 0 4px 15px rgba(102, 126, 234, 0.4);\n    }\n\n    &::after {\n      content: '';\n      position: absolute;\n      top: -2px;\n      left: -2px;\n      right: -2px;\n      bottom: -2px;\n      background: linear-gradient(45deg, #667eea, #764ba2, #f093fb, #f5576c);\n      border-radius: inherit;\n      z-index: -1;\n      opacity: 0;\n      transition: opacity 0.3s ease;\n    }\n\n    &:hover::after {\n      opacity: 1;\n    }\n  }\n\n  // User Guide Button Styling\n  .user-guide-btn {\n    position: relative;\n    padding: 8px 16px;\n    border-radius: 12px;\n    background: rgba(102, 126, 234, 0.1);\n    border: 2px solid rgba(102, 126, 234, 0.2);\n    color: #667eea;\n    font-weight: 600;\n    transition: all 0.3s ease;\n    backdrop-filter: blur(10px);\n    overflow: hidden;\n\n    [data-coreui-theme=\"dark\"] & {\n      background: rgba(102, 126, 234, 0.15);\n      border-color: rgba(102, 126, 234, 0.3);\n      color: #8da3f0;\n    }\n\n    &::before {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: -100%;\n      width: 100%;\n      height: 100%;\n      background: linear-gradient(90deg, \n        rgba(255, 255, 255, 0) 0%,\n        rgba(255, 255, 255, 0.3) 50%,\n        rgba(255, 255, 255, 0) 100%);\n      transition: left 0.5s ease;\n      z-index: 1;\n    }\n\n    &:hover {\n      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n      border-color: #667eea;\n      color: white;\n      transform: translateY(-2px);\n      box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);\n\n      &::before {\n        left: 100%;\n      }\n\n      .user-guide-text {\n        color: white;\n      }\n    }\n\n    &:focus {\n      box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.3);\n      outline: none;\n    }\n\n    .user-guide-text {\n      position: relative;\n      z-index: 2;\n      font-size: 0.875rem;\n      letter-spacing: 0.5px;\n      transition: color 0.3s ease;\n    }\n\n    .icon {\n      position: relative;\n      z-index: 2;\n      transition: all 0.3s ease;\n    }\n\n    // Animation for book icon\n    &:hover .icon {\n      animation: bookFlip 0.6s ease;\n    }\n  }\n\n  // Dropdown enhancements\n  .dropdown-menu {\n    border: none;\n    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);\n    border-radius: 12px;\n    padding: 8px;\n    backdrop-filter: blur(20px);\n    background: rgba(255, 255, 255, 0.95);\n    \n    [data-coreui-theme=\"dark\"] & {\n      background: rgba(33, 37, 41, 0.95);\n      box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n    }\n\n    .dropdown-item {\n      border-radius: 8px;\n      transition: all 0.2s ease;\n      margin: 2px 0;\n      \n      &:hover {\n        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n        color: white;\n        transform: translateX(4px);\n      }\n\n      &.text-danger:hover {\n        background: linear-gradient(135deg, #ff416c 0%, #ff4b2b 100%);\n      }\n    }\n  }\n}\n\n// Enhanced Password Change Modal\n.password-change-modal {\n  .modal-content {\n    border: none;\n    border-radius: 20px;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);\n    backdrop-filter: blur(20px);\n    background: rgba(255, 255, 255, 0.98);\n    \n    [data-coreui-theme=\"dark\"] & {\n      background: rgba(33, 37, 41, 0.98);\n    }\n  }\n\n  .modal-header {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n    border-radius: 20px 20px 0 0;\n    padding: 1.5rem 2rem;\n    \n    .modal-title {\n      font-weight: 600;\n      display: flex;\n      align-items: center;\n      \n      .icon {\n        margin-right: 12px;\n        filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));\n      }\n    }\n    \n    .btn-close {\n      filter: brightness(0) invert(1);\n      opacity: 0.8;\n      transition: all 0.2s ease;\n      \n      &:hover {\n        opacity: 1;\n        transform: scale(1.1);\n      }\n    }\n  }\n\n  .modal-body {\n    padding: 2rem;\n    \n    .password-form-card {\n      background: rgba(255, 255, 255, 0.7);\n      backdrop-filter: blur(10px);\n      border: 1px solid rgba(255, 255, 255, 0.3);\n      border-radius: 16px;\n      padding: 2rem;\n      position: relative;\n      overflow: hidden;\n      \n      [data-coreui-theme=\"dark\"] & {\n        background: rgba(255, 255, 255, 0.05);\n        border-color: rgba(255, 255, 255, 0.1);\n      }\n      \n      &::before {\n        content: '';\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        height: 3px;\n        background: linear-gradient(90deg, #667eea, #764ba2, #f093fb, #f5576c);\n        background-size: 300% 100%;\n        animation: gradientShift 3s ease-in-out infinite;\n      }\n    }\n  }\n\n  // Enhanced form inputs\n  .password-input-group {\n    position: relative;\n    margin-bottom: 1.5rem;\n    \n    .form-label {\n      font-weight: 600;\n      color: #495057;\n      margin-bottom: 0.75rem;\n      \n      [data-coreui-theme=\"dark\"] & {\n        color: #e9ecef;\n      }\n    }\n    \n    .input-group {\n      position: relative;\n      \n      .form-control {\n        border: 2px solid #e9ecef;\n        border-radius: 12px;\n        padding: 12px 16px;\n        font-size: 1rem;\n        transition: all 0.3s ease;\n        background: rgba(255, 255, 255, 0.9);\n        \n        [data-coreui-theme=\"dark\"] & {\n          background: rgba(255, 255, 255, 0.05);\n          border-color: rgba(255, 255, 255, 0.1);\n          color: #e9ecef;\n        }\n        \n        &:focus {\n          border-color: #667eea;\n          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n          background: white;\n          \n          [data-coreui-theme=\"dark\"] & {\n            background: rgba(255, 255, 255, 0.1);\n          }\n        }\n        \n        &.is-invalid {\n          border-color: #dc3545;\n          box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);\n        }\n        \n        &:not(:placeholder-shown) {\n          background: rgba(102, 126, 234, 0.02);\n          \n          [data-coreui-theme=\"dark\"] & {\n            background: rgba(255, 255, 255, 0.08);\n          }\n        }\n      }\n      \n      .input-group-text {\n        border: 2px solid #e9ecef;\n        border-left: none;\n        border-radius: 0 12px 12px 0;\n        background: transparent;\n        cursor: pointer;\n        transition: all 0.3s ease;\n        \n        [data-coreui-theme=\"dark\"] & {\n          border-color: rgba(255, 255, 255, 0.1);\n        }\n        \n        &:hover {\n          background: rgba(102, 126, 234, 0.1);\n          border-color: #667eea;\n          \n          .icon {\n            color: #667eea;\n            transform: scale(1.1);\n          }\n        }\n        \n        .icon {\n          transition: all 0.2s ease;\n          color: #6c757d;\n          \n          [data-coreui-theme=\"dark\"] & {\n            color: #adb5bd;\n          }\n        }\n      }\n    }\n  }\n\n  // Password strength indicator\n  .password-strength-indicator {\n    margin-top: 1rem;\n    \n    .strength-header {\n      display: flex;\n      justify-content: space-between;\n      align-items: center;\n      margin-bottom: 0.5rem;\n      \n      .strength-label {\n        font-size: 0.875rem;\n        color: #6c757d;\n        font-weight: 500;\n        \n        [data-coreui-theme=\"dark\"] & {\n          color: #adb5bd;\n        }\n      }\n      \n      .strength-text {\n        font-size: 0.875rem;\n        font-weight: 600;\n        text-transform: uppercase;\n        letter-spacing: 0.5px;\n      }\n    }\n    \n    .progress {\n      height: 8px;\n      border-radius: 20px;\n      background: rgba(0, 0, 0, 0.1);\n      overflow: hidden;\n      \n      [data-coreui-theme=\"dark\"] & {\n        background: rgba(255, 255, 255, 0.1);\n      }\n      \n      .progress-bar {\n        border-radius: 20px;\n        transition: all 0.5s ease;\n        position: relative;\n        \n        &::after {\n          content: '';\n          position: absolute;\n          top: 0;\n          left: 0;\n          right: 0;\n          bottom: 0;\n          background: linear-gradient(90deg, \n            rgba(255, 255, 255, 0.3) 0%,\n            rgba(255, 255, 255, 0.1) 50%,\n            rgba(255, 255, 255, 0.3) 100%);\n          animation: shimmer 2s infinite;\n        }\n      }\n    }\n    \n    .strength-requirements {\n      font-size: 0.75rem;\n      color: #6c757d;\n      margin-top: 0.5rem;\n      line-height: 1.4;\n      \n      [data-coreui-theme=\"dark\"] & {\n        color: #adb5bd;\n      }\n    }\n  }\n\n  // Password match indicator\n  .password-match-indicator {\n    margin-top: 0.5rem;\n    \n    .match-text {\n      font-size: 0.875rem;\n      display: flex;\n      align-items: center;\n      font-weight: 500;\n      \n      .icon {\n        margin-right: 0.5rem;\n        transition: all 0.2s ease;\n      }\n      \n      &.text-success .icon {\n        animation: checkmark 0.5s ease;\n      }\n      \n      &.text-danger .icon {\n        animation: shake 0.5s ease;\n      }\n    }\n  }\n\n  // Alert enhancements\n  .alert {\n    border: none;\n    border-radius: 12px;\n    padding: 1rem 1.25rem;\n    backdrop-filter: blur(10px);\n    \n    &.alert-danger {\n      background: rgba(220, 53, 69, 0.1);\n      color: #721c24;\n      border-left: 4px solid #dc3545;\n      \n      [data-coreui-theme=\"dark\"] & {\n        background: rgba(220, 53, 69, 0.2);\n        color: #f8d7da;\n      }\n    }\n    \n    &.alert-success {\n      background: rgba(25, 135, 84, 0.1);\n      color: #0a3622;\n      border-left: 4px solid #198754;\n      \n      [data-coreui-theme=\"dark\"] & {\n        background: rgba(25, 135, 84, 0.2);\n        color: #d1e7dd;\n      }\n    }\n  }\n\n  // Footer enhancements\n  .modal-footer {\n    padding: 1.5rem 2rem 2rem;\n    border: none;\n    \n    .btn {\n      border-radius: 12px;\n      padding: 12px 24px;\n      font-weight: 600;\n      transition: all 0.3s ease;\n      position: relative;\n      overflow: hidden;\n      \n      &::before {\n        content: '';\n        position: absolute;\n        top: 50%;\n        left: 50%;\n        width: 0;\n        height: 0;\n        background: rgba(255, 255, 255, 0.2);\n        border-radius: 50%;\n        transform: translate(-50%, -50%);\n        transition: all 0.5s ease;\n      }\n      \n      &:hover::before {\n        width: 200px;\n        height: 200px;\n      }\n      \n      &.btn-primary {\n        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n        border: none;\n        \n        &:hover {\n          transform: translateY(-2px);\n          box-shadow: 0 8px 25px rgba(102, 126, 234, 0.4);\n        }\n        \n        &:disabled {\n          background: #6c757d;\n          transform: none;\n          box-shadow: none;\n        }\n      }\n      \n      &.btn-light {\n        background: rgba(248, 249, 250, 0.9);\n        backdrop-filter: blur(10px);\n        border: 2px solid rgba(0, 0, 0, 0.1);\n        \n        [data-coreui-theme=\"dark\"] & {\n          background: rgba(255, 255, 255, 0.1);\n          border-color: rgba(255, 255, 255, 0.2);\n          color: #e9ecef;\n        }\n        \n        &:hover {\n          background: rgba(248, 249, 250, 1);\n          transform: translateY(-1px);\n          \n          [data-coreui-theme=\"dark\"] & {\n            background: rgba(255, 255, 255, 0.2);\n          }\n        }\n      }\n    }\n  }\n}\n\n// Animations\n@keyframes gradientShift {\n  0% { background-position: 0% 50%; }\n  50% { background-position: 100% 50%; }\n  100% { background-position: 0% 50%; }\n}\n\n@keyframes shimmer {\n  0% { transform: translateX(-100%); }\n  100% { transform: translateX(100%); }\n}\n\n@keyframes checkmark {\n  0% { transform: scale(0.8); opacity: 0; }\n  50% { transform: scale(1.1); }\n  100% { transform: scale(1); opacity: 1; }\n}\n\n@keyframes shake {\n  0%, 100% { transform: translateX(0); }\n  10%, 30%, 50%, 70%, 90% { transform: translateX(-2px); }\n  20%, 40%, 60%, 80% { transform: translateX(2px); }\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes bookFlip {\n  0% { transform: rotateY(0deg); }\n  50% { transform: rotateY(20deg) scale(1.1); }\n  100% { transform: rotateY(0deg); }\n}\n\n// Loading spinner enhancement\n.spinner-border-sm {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n// Responsive enhancements\n@media (max-width: 768px) {\n  .app-header {\n    .user-guide-btn {\n      padding: 6px 12px;\n      \n      .user-guide-text {\n        font-size: 0.8rem;\n      }\n    }\n  }\n\n  .password-change-modal {\n    .modal-content {\n      margin: 1rem;\n      border-radius: 16px;\n    }\n    \n    .modal-header {\n      padding: 1rem 1.5rem;\n      border-radius: 16px 16px 0 0;\n    }\n    \n    .modal-body {\n      padding: 1.5rem;\n      \n      .password-form-card {\n        padding: 1.5rem;\n      }\n    }\n    \n    .modal-footer {\n      padding: 1rem 1.5rem 1.5rem;\n      \n      .btn {\n        padding: 10px 20px;\n        font-size: 0.9rem;\n      }\n    }\n  }\n  \n  .password-input-group {\n    margin-bottom: 1rem;\n    \n    .input-group .form-control {\n      padding: 10px 14px;\n      font-size: 0.9rem;\n    }\n  }\n}\n\n// Medium screens - hide text, show only icon\n@media (max-width: 1199px) {\n  .app-header {\n    .user-guide-btn {\n      .user-guide-text {\n        display: none;\n      }\n    }\n  }\n}\n\n// Dark theme specific enhancements\n[data-coreui-theme=\"dark\"] {\n  .password-change-modal {\n    .modal-content {\n      box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);\n    }\n  }\n  \n  .password-strength-indicator {\n    .progress {\n      background: rgba(255, 255, 255, 0.1);\n    }\n  }\n}\n\n// Utility classes\n.cursor-pointer {\n  cursor: pointer !important;\n}\n\n.glassmorphism {\n  backdrop-filter: blur(20px);\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.gradient-text {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.fade-in-up {\n  animation: fadeInUp 0.5s ease forwards;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
